import isCatalogFeedProduct from '../../utils/isCatalogFeedProduct'
import filterOutletCatalogProducts from './outlet/filterOutletCatalogProducts'
import { getProductAvatarFileName } from './gifts/giftFundHelpers'

const isNotArchived = (entity) => entity?.isArchived !== true

const readShopRemainQuantity = (shop, productId) => {
  const row = (Array.isArray(shop?.remains) ? shop.remains : []).find(
    (item) => String(item?.productId) === String(productId)
  )
  const raw = Number(row?.quantity)
  return Number.isFinite(raw) && raw > 0 ? raw : 0
}

const normalizeProduct = (product, source, brandName = '', remainQuantity = 0) => {
  const priceRaw = product.price
  const price = priceRaw != null && priceRaw !== '' ? Number(priceRaw) : null
  return {
    id: product.id,
    source,
    key: `${source}:${product.id}`,
    name: product.name?.trim() || '',
    barcode: product.barcode?.trim() || '',
    brandId: product.brandId,
    brandName: brandName || product.brandName?.trim() || '',
    categoryId: product.categoryId,
    subcategoryId: product.subcategoryId,
    avatarFileName: getProductAvatarFileName(product),
    price: Number.isFinite(price) ? price : null,
    descriptionShort:
      typeof product.descriptionShort === 'string' ? product.descriptionShort.trim() : '',
    remainQuantity,
  }
}

export const buildRelatedProductSearchIndex = ({
  products = [],
  outletProducts = [],
  categories = [],
  brands = [],
  outletShop = {},
  premiumOnlineShop = {},
}) => {
  const categoryById = Object.fromEntries(categories.map((category) => [category.id, category]))
  const brandById = Object.fromEntries(brands.map((brand) => [brand.id, brand]))

  const premiumItems = products
    .filter(isCatalogFeedProduct)
    .filter((product) => {
      const brand = brandById[product.brandId]
      const category = categoryById[product.categoryId]

      return isNotArchived(brand) && isNotArchived(category)
    })
    .map((product) =>
      normalizeProduct(
        product,
        'premium',
        brandById[product.brandId]?.name?.trim() || '',
        readShopRemainQuantity(premiumOnlineShop, product.id)
      )
    )
    .filter((product) => product.name)

  const filteredOutletProducts = filterOutletCatalogProducts({
    products: outletProducts,
    brands,
    categories,
    remains: outletShop,
    brandIds: [],
  })

  const outletItems = filteredOutletProducts
    .map((product) =>
      normalizeProduct(product, 'outlet', '', readShopRemainQuantity(outletShop, product.id))
    )
    .filter((product) => product.name)

  return [...premiumItems, ...outletItems]
}

export default buildRelatedProductSearchIndex

/** Merge catalog fields onto productRefs for BO tiles (name, avatar, price, remain). */
export const enrichBlogProductRefs = (productRefs, searchIndex) => {
  if (!Array.isArray(productRefs) || !productRefs.length) return Array.isArray(productRefs) ? productRefs : []
  const list = Array.isArray(searchIndex) ? searchIndex : []
  if (!list.length) return productRefs

  let changed = false
  const next = productRefs.map((ref) => {
    if (!ref?.productId) return ref
    const catalog = ref.catalog === 'outlet' ? 'outlet' : 'premium'
    const found = list.find((item) => item.id === ref.productId && item.source === catalog)
    if (!found) return ref
    const avatarFileName = found.avatarFileName || null
    const price = found.price != null ? found.price : null
    const name = found.name || ref.name || ''
    const brandName = found.brandName || ref.brandName || ''
    const descriptionShort = found.descriptionShort || ref.descriptionShort || ''
    const remainQuantity = found.remainQuantity != null ? found.remainQuantity : null
    if (
      ref.avatarFileName === avatarFileName &&
      ref.price === price &&
      ref.name === name &&
      ref.brandName === brandName &&
      ref.descriptionShort === descriptionShort &&
      ref.remainQuantity === remainQuantity
    ) {
      return ref
    }
    changed = true
    return {
      ...ref,
      catalog,
      name,
      avatarFileName,
      price,
      brandName,
      descriptionShort,
      remainQuantity,
    }
  })
  return changed ? next : productRefs
}
